var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-app-bar',{attrs:{"app":"","color":"red darken-4","dark":""}},[_c('app-navigation')],1),_c('v-main',{attrs:{"transition":"slide-x-transition"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }